module.exports = __webpack_public_path__ + "static/media/91wB6V1OBEL._AC_SL1500_.ac5da903.jpg";